import { ResponseDto } from '@diritto/common/base/response.dto';
import { CreateEpisodeDto, UpdateEpisodeDto } from '@diritto/common/episode/dtos/episode-edit.dto';
import { EpisodeEditResponseDto } from '@diritto/common/episode/dtos/episode-edit.response.dto';
import {
  EpisodeFileResponseDto,
  EpisodeIncludeFileResponseDto,
} from '@diritto/common/episode/dtos/episode-file.response.dto';
import { WsEpisodesResponseDto } from '@diritto/common/episode/dtos/ws-episode.response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { generateUrl } from '@diritto/common/utils/urls';
import { AxiosRequestConfig } from 'axios';

export class WsEpisodeApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async findFirstOpenedInMonth(yearMonth: string, options?: AxiosRequestConfig) {
    const res = await this.http.get<WsEpisodesResponseDto>(
      generateUrl(`${this.url}/workspace/episodes/monthly`, {
        yearMonth,
      }),
      options,
    );
    return res.data;
  }

  async uploadIncludeFiles(data: FormData): Promise<EpisodeIncludeFileResponseDto> {
    const res = await this.http.post<FormData, EpisodeIncludeFileResponseDto>(
      `${this.url}/episodes/edit/include-files`,
      data,
    );
    return res.data;
  }

  async uploadFiles(data: FormData) {
    const res = await this.http.post<FormData, EpisodeFileResponseDto>(`${this.url}/episodes/edit/files`, data);
    return res.data;
  }

  async create(data: CreateEpisodeDto): Promise<EpisodeEditResponseDto> {
    const res = await this.http.post<CreateEpisodeDto, EpisodeEditResponseDto>(`${this.url}/episodes/edit`, data);
    return res.data;
  }

  async update(episodeId: number, data: UpdateEpisodeDto): Promise<EpisodeEditResponseDto> {
    const res = await this.http.put<UpdateEpisodeDto, EpisodeEditResponseDto>(
      `${this.url}/episodes/edit/${episodeId}`,
      data,
    );
    return res.data;
  }

  async getEpisodeEdit(episodeId: number, options?: AxiosRequestConfig): Promise<EpisodeEditResponseDto> {
    const res = await this.http.get<EpisodeEditResponseDto>(`${this.url}/episodes/edit/${episodeId}`, options);
    return res.data;
  }

  async delete(episodeId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/episodes/edit/${episodeId}`);
    return res.data;
  }
}
